<template>
  <li class="item button-publish bt-copy_url">
    <a href="javascript:;" class="kp-modular-publish animate-in" @click="boxSave(true)">
      <i class="kp-panel-publish"></i>
      <span class="txt">{{ $t('general.actions.publish') }}</span>
    </a>
  </li>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: mapActions([
    'boxSave',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Publish.vue?5e23df4e
 **/